import { initializeState } from '../../../utilities/storageUtils';
import datesActionTypes from './dates.types';

const INITIAL_STATE = {
  checkinDateSelection: undefined,
  checkoutDateSelection: undefined
};

const datesReducer = (state, action) => {
  state = initializeState(state, INITIAL_STATE);
  switch (action.type) {
    case datesActionTypes.UPDATE_DATES:
      return {
        ...state,
        checkinDateSelection: action.checkinDateSelection,
        checkoutDateSelection: action.checkoutDateSelection
      };
    default:
      return state;
  }
};

export default datesReducer;
